import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=3775bb94&scoped=true"
import script from "./Detailed.vue?vue&type=script&lang=js"
export * from "./Detailed.vue?vue&type=script&lang=js"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=3775bb94&prod&lang=css"
import style1 from "./Detailed.vue?vue&type=style&index=1&id=3775bb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775bb94",
  null
  
)

export default component.exports